import ApiService from '../../_services/ApiService';
import { getDateAsPerFormat } from './dateSetter';

const fetchApplications = async (
    offerId,
    searchQuery = '',
    platform = '',
    status = '',
    niche ='',
    id,
    rowsPerPage,
    page
) => {
    try {
        const params = {
            campaign_id: offerId,
            campaign_type: 'bartercampaign',
            search: searchQuery,
            limit: rowsPerPage,
            offset: page * rowsPerPage,
        };

        if (id) params.id = id;
        if (platform && platform !== 'All') params.platform = platform;
        if (status && status !== 'All') params.status = status;
        if (niche && niche !== 'All') params.niche = niche;

        const response = await ApiService.get('all_submissions', params);

        const list = Array.isArray(response?.data.results)
            ? response.data.results
            : [];

        const mappedList = list.map((item) => ({
            id: item.id,
            name: item.creator_name || "NA",
            code: item.creator_id || "NA",
            creatorHandle: item.creator_handle_name || "",
            applied: getDateAsPerFormat(item.applied_at, "dd/MM/yyyy"),
            followers: item.followers || "NA",
            location: item.address || "NA",
            shippingStatus: item.shipping_status || "NA",
            deliverablesStatus: item.deliverables_status || "NA",
            livePostStatus: item.live_status || "NA",
            status: item.status || "NA",
            pitch: item.pitch || "NA",
            groupkey: `${item.creator_name || "NA"}_${item.creator_id || "NA"}`,
            applied_at: item.applied_at,
            address: item.address,
            assesment_link: item.assesment_link,
            deliverable_upload: item.deliverable_upload,
            deliverable_re_upload: item.deliverable_re_upload,
            live_link: item.live_link,
            final_live_link: item.final_live_link,
            landmark: item.landmark,
            reason: item.reason,
            upload_date: item.upload_date,
            re_upload_date: item.re_upload_date,
            final_live_date: item.final_live_date,
            live_date: item.live_date,
            tracking_link: item.tracking_link,
            shipping_status: item.shipping_status,
            deliverables_status: item.deliverables_status,
            feedback: item.feedback,
            reason: item.reason,
            creator_agency_id: item.creator_agency_id,
            creator_logo: item.creator_logo,
            creator_type: item.creator_type,
            creator_handler_type: item.creator_handler_type,
            phone_number: item.phone_number,
            is_delivered: item.is_delivered,
            content_format: item.content_format,
            creator_handle_rating: item.creator_handle_rating,
            creator_handle_niche: item.creator_handle_niche,
            deliverables_links: item.deliverables_links || [],
            live_links: item.live_links || [],
            rejection_reasons: item.rejection_reasons || [],
            other_message: item.other_message,
            closed: item.closed,
            campaign_type: item.campaign_type,
            creator_id: item.creator_id,
            creator_name: item.creator_name,
            creator_handle_name: item.creator_handle_name,
            live_status: item.live_status || 'NA',
            deliverables_status: item.deliverables_status || 'NA',
            shipping_status: item.shipping_status || 'NA',
            creator_handle_id: item.creator_handle_id || 'NA'
        }));

        return {
            list: mappedList,
            count: response?.data?.count || 0,
        };

    } catch (error) {
        console.error('Failed to fetch applications:', error);
        return { list: [], count: 0 };
    }
};

export default fetchApplications;
